.label {
  position: relative;
  color: rgba(0, 0, 0, 0.5);
}
.label:before {
  content: attr(data-text);
  position: absolute;
  overflow: hidden;
  max-width: 100%;
  white-space: nowrap;
  color: #7cbc8f;
  animation: loading 10s linear;
}
@keyframes loading {
  0% {
    max-width: 0;
  }
}
